import React from 'react';
import ReactSelect from 'react-select';

var CurrentUser = require("lib/account/CurrentUser");
var AccountPlans = require("lib/account/AccountPlans");

var Modal = require("components/utility/AltModal");

require("org/roster/rostering_method_modal.scss");

class RosteringMethodModal extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        this.state = {
            org: {},
            orgType: null,
            rosteringMethod: {},
            rosteringManager: {}  
        };
    }

    ////////////// HELPERS //////////////

    findPrefsHashAttribute(key1, key2, key3, nestedObject) {
        if (nestedObject && nestedObject[key1] && nestedObject[key1][key2] && nestedObject[key1][key2][key3]) {
            return nestedObject[key1][key2][key3];
        }
        return null;
    }

    formatRosteringData() {
        var { rosteringManager, rosteringMethod } = this.state

        // update this if we allow wizards to update more org prefs
        if (!_.isEmpty(rosteringManager) && !_.isEmpty(rosteringMethod)) {
            return { prefs: { 'rostering_method': { 'method': rosteringMethod.value, 'manager': rosteringManager.value } } }
        }
    }

    //////// MODAL CONTROLS ACTIONS ///////

    show() {
        this.refs.modal.show();
    }

    ////////////// STATE SETTERS //////////////

    setRosteringMethod() {
        var { org } = this.state
        var rosteringMethodValue = this.findPrefsHashAttribute('prefs', 'rostering_method', 'method', org)
        var rosteringManagerValue = this.findPrefsHashAttribute('prefs', 'rostering_method', 'manager', org)

        if (rosteringMethodValue) {
            this.setState({ rosteringMethod: { label: rosteringMethodValue, value: rosteringMethodValue } })
        }

        if (rosteringManagerValue) {
            this.setState({ rosteringManager: { label: rosteringManagerValue, value: rosteringManagerValue } })
        }
    }

    // sets school or district org in state
    setOrg() {
        var { schoolOrg, districtOrg } = this.props

        if (!_.isEmpty(schoolOrg)) {
            this.setState({ org: schoolOrg, orgType: SCHOOL_ORG_TYPE }, () => this.setRosteringMethod() )
        } else if (!_.isEmpty(districtOrg)) {
            this.setState({ org: districtOrg, orgType: DISTRICT_ORG_TYPE }, () => this.setRosteringMethod())
        }
    }

    ////////////// UPDATE METHODS //////////////

    updateSchoolOrg() {
        var { org } = this.state

        var updateHash = this.formatRosteringData()
        if (!_.isEmpty(updateHash)) {
            CurrentUser.api().patchSchoolOrg(org.id, { school_org: updateHash }, $wr.apiHandler((response) => {
                if (response.school_org.errors) {
                    window.wrNotifications.triggerDropDownNotification({
                        title: "Sorry!", text: response.school_org.errors.join(", "),
                        icon: "exclamation-sign", type: "error"
                    });
                } else {
                    setTimeout(() => {
                        window.wrNotifications.triggerDropDownNotification({
                            title: "Success!", text: "It worked like magic.", icon: "ok-sign"
                        });
                    }, 1000);
                }
            }));
        }
    }

    updateDistrictOrg() {
        var { org } = this.state

        var updateHash = this.formatRosteringData()
        if (!_.isEmpty(updateHash)) {
            CurrentUser.api().patchDistrictOrg(org.id, { district_org: updateHash }, $wr.apiHandler((response) => {
                window.wrNotifications.triggerDropDownNotification({
                    title: "District Org Updated", icon: "ok-sign"
                });

                setTimeout(() => { window.location.reload() }, 1000);
            }));
        }
    }

    updateRosteringMethod() {
        var { orgType } = this.state

        if (orgType == SCHOOL_ORG_TYPE) {
            this.updateSchoolOrg()
        } else if (orgType == DISTRICT_ORG_TYPE) {
            this.updateDistrictOrg()
        }
    }

    ////////////// RENDER METHODS //////////////

    renderRosteringMethodSection() {
        var { org, rosteringManager, rosteringMethod } = this.state

        if (_.isEmpty(org) || _.isEmpty(org.prefs)) { return null }

        var rosteringMethodOptions = _.map(ALL_METHOD_OPTIONS, m => {
            return { value: m, label: m }
        })

        var rosteringManagerOptions = _.map(ALL_MANAGER_OPTIONS, m => {
            return { value: m, label: m }
        })

        return (
            <div className="rosteringSection">
                <div className="inputContainer">
                    <div className='inputLabel'>Manager:</div>
                    <ReactSelect name="rosteringManager" value={rosteringManager} clearable={false}
                        options={rosteringManagerOptions} onChange={(rm) => this.setState({ rosteringManager: rm })} />
                </div>
                <div className="inputContainer">
                    <div className='inputLabel'>Method:</div>
                    <ReactSelect name="rosteringManager" value={rosteringMethod} clearable={false}
                        options={rosteringMethodOptions} onChange={(rm) => this.setState({ rosteringMethod: rm })} />
                </div>
                {!_.isEmpty(rosteringManager) && !_.isEmpty(rosteringMethod) && (
                    <div className='btnContainer saveRosteringMethodBtn'>
                        <button onClick={this.updateRosteringMethod} className='btn btn-primary' type='submit'>Save</button>
                    </div>
                )}
            </div>
        )
    }

    render() {
        return (
            <div className="rosteringMethodModal">
                <Modal headerText="Rostering Method" ref="modal">
                    {this.renderRosteringMethodSection()}
                </Modal>
            </div>
        )
    }

    componentDidMount() {
        this.setOrg()
    }

};

var SCHOOL_ORG_TYPE = 'schoolOrg'
var DISTRICT_ORG_TYPE = 'districtOrg'

var MANUAL = "manual";
var GOOGLE = "google";
var CLEVER = "clever";
var ALL_METHOD_OPTIONS = [MANUAL, GOOGLE, CLEVER]

var INDIVIDUAL = 'individual'
var DISTRICT_ORG = 'district_org'
var SCHOOL_ORG = 'school_org'
var ALL_MANAGER_OPTIONS = [INDIVIDUAL, DISTRICT_ORG, SCHOOL_ORG]

RosteringMethodModal.propTypes = StrictPropTypes({
    schoolOrg: PropTypes.object,
    districtOrg: PropTypes.object,
});

module.exports = RosteringMethodModal;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/RosteringMethodModal.js